export const companyWasteTranslationKeyById: Record<string, string> = {
  '113102': 'Waste_113102',
  '114904': 'Waste_114904',
  '119932': 'Waste_119932',
  '119939': 'Waste_119939',
  '159905': 'Waste_159905',
  '161502': 'Waste_161502',
  '161702': 'Waste_161702',
  '160303': 'Waste_160303',
  '119995': 'Waste_119995',
  '122111': 'Waste_122111',
  '131201': 'Waste_131201',
  '149946': 'Waste_149946',
  '162101': 'Waste_162101',
  '173201': 'Waste_173201',
  '191201': 'Waste_191201',
  '181120': 'Waste_181120',
  '144866': 'Waste_144866',
  '172901': 'Waste_172901',
  '191103': 'Waste_191103',
  '191104': 'Waste_191104',
  '70980036': 'Waste_70980036',
  '71550032': 'Waste_71550032',
  '71560032': 'Waste_71560032',
  '71570232': 'Waste_71570232',
  '72500033': 'Waste_72500033',
  '71520332': 'Waste_71520332',
  '71510132': 'Waste_71510132',
  '161304': 'Waste_161304',
  '160111': 'Waste_160111',
  '160123': 'Waste_160123',
  '160410': 'Waste_160410',
  '160411': 'Waste_160411',
  '160414': 'Waste_160414',
  '160415': 'Waste_160415',
  '161806': 'Waste_161806',
  '160403': 'Waste_160403',
  '161901': 'Waste_161901',
}

export const companySizeTranslationKeyByPath: Record<string, string> = {
  tralle: 'Size_tralle',
  standard: 'Size_standard',
  stor: 'Size_stor',
  xxl: 'Size_xxl',
}
